<!-- <button class="btn btn-link text-xs no-underline">Terms of Conditions</button>
| -->
<button class="btn btn-link text-xs no-underline">Cookies settings</button>
